import React from "react";

// import { TreeList } from 'devextreme-react/tree-list';
import DataGrid, { Button, Column } from "devextreme-react/data-grid";

// import { LoadIndicator } from 'devextreme-react/load-indicator';
// import { Case, Switch } from 'react-context-switch';
// import { useApi } from 'starfx/react';
import { useFxDispatch, useFxSelector } from "@app/statefx";
import { selectCollectionByFFID } from "@app/statefx/selectors/ds-collection.sel";
import { AppState } from "@app/statefx/xstore";
import { getInvoicePayments } from "@app/statefx/xThunks/ds-colection";
import { setEditingCollection } from "@app/statefx/xThunks/uiInvoiceOverall";

export const IFCollectionHistory = ({ ffid }: { ffid: number }) => {
  const dispatch = useFxDispatch();
  const theRoot = useFxSelector((s: AppState) =>
    selectCollectionByFFID(s, { ffid: ffid })
  );

  /// DONT'T. THIS CRASHES THE APP IN BROWSER, NOT IN DELPHI
  // const thunk = useApi(getInvoicePayments({ ffid: ffid }));
  // React.useEffect(() => {
  //   dispatch(thunk.action);
  // }, [ffid]);

  React.useEffect(() => {
    dispatch(getInvoicePayments({ ffid: ffid }));
  }, [ffid]);

  return (
    <DataGrid
      dataSource={theRoot}
      keyExpr="_ID"
      selection={{ mode: "single" }}
      editing={{
        allowUpdating: false,
        allowDeleting: true,
        allowAdding: false,
        mode: "row",
      }}
    >
      <Column dataField="DATA_I" dataType="date" format="dd.MM.yyyy" />
      <Column dataField="VALOARE_I" />
      <Column dataField="MONEDA_I" />
      <Column dataField="AMA_ID" visible={false} />
      <Column type="buttons">
        <Button
          text="Detalii"
          // icon={'info'}
          onClick={(e) => {
            dispatch(setEditingCollection({ iid: e.row.data._ID }));
          }}
        />
      </Column>
    </DataGrid>
  );
};
